<app-modal
  [open]="open()"
  [title]="'SIGNED_LEGAL_DOCUMENTS_MODAL_TITLE'"
  [showCancel]="false"
  [showConfirm]="false"
  (cancelled)="closed.emit()"
>
  <ul class="doc-list">
    @for (doc of documents(); track doc.documentType) {
      <li class="doc-item">
        <div class="doc-info">
          <span class="doc-name">{{ 'LEGAL_DOCUMENT_' + doc.documentType | translate }}</span>
          <span>{{ 'ADMIN_LEGAL_DOCS_TRANSLATION_SIGNED_ON' | translate: { signedOn: approvalDate() } }}</span>
        </div>

        <a
          app-button
          variant="primary"
          class="download-btn"
          [href]="doc.url"
          target="_blank"
          rel="noopener noreferrer"
          (click)="documentDownloaded.emit(doc)"
        >
          {{ 'ADMIN_LEGAL_DOCS_HEADER_TRANSLATION_DOWNLOAD' | translate }}
        </a>
      </li>
    }
  </ul>
</app-modal>
